var _defineProperty = require("/var/lib/jenkins/jobs/decision-aids-app/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 26);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("create-react-class");
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t) {
  e.exports = require("underscore");
}, function (e, t) {
  e.exports = require("draft-js");
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u, d;
  l = n(0), c = n(1), u = n(2).object, s = n(3), r = n(16), a = n(6), o = n(8), d = {
    font: {
      fontSize: "8pt",
      fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif"
    },
    footnotesList: {
      listStyle: "lower-alpha"
    },
    sup: {
      marginLeft: "5px"
    }
  }, i = c({
    displayName: "OutcomeTable",
    propTypes: {
      data: u.isRequired
    },
    mixins: [r, a("es:outcome")],
    _getNormalizedFootnoteIndex: function _getNormalizedFootnoteIndex(e) {
      var t;
      return null == this.normalizedFootnotesOrder && (this.normalizedFootnotesOrder = []), (t = this.normalizedFootnotesOrder.indexOf(e)) < 0 ? this.normalizedFootnotesOrder.push(e) : t + 1;
    },
    getAlphabeticalSup: function getAlphabeticalSup(e) {
      return e ? e.split(" ").map((t = this, function (e) {
        var n;
        return n = t._getNormalizedFootnoteIndex(Number.parseInt(e)), o.numberToLetter(n);
      })).join(",") : "";
      var t;
    },
    renderCells: function renderCells(e, t, n) {
      return null == t && (t = {}), null == n && (n = !1), e.map((r = this, function (e, o) {
        var i, a, c, u, p, h, f, m, g, y, E;
        return a = e.colspan, f = e.rowspan, y = e.textContent, E = e.type, u = e.name, m = e.sup, null == E && (E = "td"), h = (null != (p = t[u]) ? p : []).join(","), c = r.getAlphabeticalSup(m), g = s.isEmpty(h) || s.isEmpty(c) ? h || c : h + "," + c, i = {
          name: u,
          rowSpan: f,
          colSpan: a,
          key: o,
          style: s.extend({}, r.props.style.cell, r.props.style[u], n ? r.props.style.thCell : void 0)
        }, l.createElement(E, i, l.createElement("span", {
          dangerouslySetInnerHTML: {
            __html: y
          }
        }), l.createElement("sup", {
          style: d.sup
        }, g));
      }));
      var r;
    },
    renderRows: function renderRows(e, t, n) {
      return null == n && (n = !1), e ? e.map((r = this, function (e, o) {
        var i;
        return i = e.cells, l.createElement("tr", {
          key: o
        }, r.renderCells(i, t, n));
      })) : null;
      var r;
    },
    renderOutcomes: function renderOutcomes() {
      var e, t, n, r;
      return n = (t = this.props.data).type, e = t.outcomes, "diag" === n ? l.createElement("tbody", null, e.map((r = this, function (e, t) {
        var n, o;
        return o = e.rows, n = e.references, r.renderRows(o, n);
      }))) : e.map(function (e) {
        return function (t, n) {
          var r, o;
          return o = t.rows, r = t.references, l.createElement("tbody", {
            key: n
          }, e.renderRows(o, r));
        };
      }(this));
    },
    renderFootnotes: function renderFootnotes(e) {
      return !e || s.isEmpty(this.normalizedFootnotesOrder) ? null : l.createElement("ol", {
        style: s.extend({}, d.font, d.footnotesList)
      }, this.normalizedFootnotesOrder.map(function (t, n) {
        var r;
        return e[t - 1] ? (r = e[t - 1].note, l.createElement("li", {
          key: n
        }, r)) : null;
      }));
    },
    renderReferences: function renderReferences(e) {
      return s.isEmpty(e) ? null : l.createElement("ol", {
        style: d.font
      }, e.map(function (e, t) {
        return l.createElement("li", {
          key: t
        }, e);
      }));
    },
    render: function render() {
      var e, t, n, r;
      return r = (t = this.props.data).thead, e = t.footnotesList, n = t.references, l.createElement("div", null, l.createElement("table", {
        style: this.props.style.table
      }, l.createElement("thead", {
        style: this.props.style.thead
      }, this.renderRows(r, null, !0)), this.renderOutcomes()), this.renderReferences(n), this.renderFootnotes(e));
    }
  }), e.exports = i;
}, function (e, t, n) {
  var r, o, i;
  o = n(32), i = n(33), r = function r(e) {
    return null == e && (e = ""), {
      _i18n: function _i18n(t, n) {
        var r, i, l, a;
        return null == n && (n = {}), r = o.startsWith(t, "/") ? t.slice(1) : o.startsWith(t, "../") ? 1 === (l = e.split(/\.|:/)).length ? t : (i = t.match(/\.\.\//g).length, a = t.replace(/\.\.\//g, ""), l.slice(0, l.length - i).concat([a]).join(".").replace(".", ":")) : e.length ? e + "." + t : t, $.t(r, n);
      },
      i18n: function i18n(e, t, n) {
        var r, o, l, a;

        if (null == t && (t = {}), null == n && (n = null), a = this._i18n(e, t), n) {
          for (o in r = {}, l = function l(e, t, n) {
            var i;
            return i = e.split("__" + o + "__"), r["text_" + o] = i[0], r["comp_" + o] = n, i[1];
          }, n) {
            a = l(a, 0, n[o]);
          }

          return r.last = a, i(r);
        }

        return a;
      }
    };
  }, e.exports = r;
}, function (e, t) {
  e.exports = require("immutable");
}, function (e, t, n) {
  var r,
      o,
      i,
      l,
      a,
      s,
      c,
      u,
      d,
      p,
      h,
      f,
      m,
      g,
      y,
      E,
      b,
      C,
      N,
      T,
      S,
      v,
      L,
      k,
      I = [].slice;
  c = n(4), p = n(7), g = n(3), h = n(34), c.AtomicBlockUtils, u = c.EditorState, s = c.ContentState, m = c.SelectionState, l = c.CompositeDecorator, d = c.Entity, f = c.Modifier, a = c.ContentBlock, i = c.CharacterMetadata, c.BlockMapBuilder, E = c.convertFromRaw, y = c.convertFromHTML, b = c.convertToRaw, S = c.genKey, o = {
    SMALL_FONT: {
      fontSize: "10px"
    },
    MODERATE_FONT: {
      fontSize: "12px"
    },
    NORMAL_FONT: {
      fontSize: "14px"
    },
    LARGE_FONT: {
      fontSize: "18px"
    },
    HUGE_FONT: {
      fontSize: "32px"
    }
  }, r = {
    TEXT_ALIGN_LEFT: "alignment--left",
    TEXT_ALIGN_RIGHT: "alignment--right",
    TEXT_ALIGN_CENTER: "alignment--center"
  }, v = function v(e) {
    var t, n, r, o, i;

    switch (e.tagName.toLowerCase()) {
      case "img":
        return null == (r = e.getAttribute("db-image")) ? null : {
          contentType: "image",
          imgId: r
        };

      case "table":
        return n = "div" === (o = e.parentNode).tagName.toLowerCase() ? o.classList.contains("inserted") ? o : o.classList.contains("outcomes-container") ? o.parentNode : null : null, t = e.outerHTML.replace(/\n/g, "").replace(/(>)\s+(<)/g, "$1$2").replace(/\s\s+/g, " "), null != n ? null == (i = n.getAttribute("appendix-type")) ? null : {
          contentType: "gdt_table",
          type: i,
          content: t
        } : {
          contentType: "dangerousHTML",
          content: t
        };

      default:
        return null;
    }
  }, k = function k(e) {
    var t;
    return null == e ? null : ((t = document.createElement("blockquote")).innerText = JSON.stringify(e), t);
  }, L = function L(e, t) {
    if (t instanceof HTMLElement) return e.parentNode.replaceChild(t, e);
  }, C = g.compose(k, v), N = function N(e) {
    return L(e, C(e));
  }, T = {
    CUSTOM_STYLE_MAP: o,
    CUSTOM_BLOCK_STYLES_CLASS_MAP: r,
    rawContentBlocksToRawContent: g.compose(p.fromJS, b, s.createFromBlockArray),
    openTableInNewWindow: function openTableInNewWindow(e, t) {
      var n, r, o, i;
      if (o = null, o = window.open("about:blank", "_blank", "resizable=yes, scrollable=yes, status=yes, menubar=no")) return o.opener = null, n = document.createElement("div"), (i = document.createElement("h3")).innerHTML = e, (r = document.createElement("div")).innerHTML = t, n.appendChild(i), n.appendChild(r), o.document.write(n.innerHTML);
    },
    getBlockRenderMap: function getBlockRenderMap(e) {
      var t;
      return t = {
        section: {
          element: "section"
        }
      }, c.DefaultDraftBlockRenderMap.merge(p.Map(g.extend(t, e)));
    },
    findTextByEntityType: function findTextByEntityType(e) {
      return function (t, n) {
        return t.findEntityRanges(function (t) {
          var n;
          return null != (n = t.getEntity()) && d.get(n).getType() === e;
        }, n);
      };
    },
    getEditorState: function getEditorState(e, t) {
      var n, r;
      if (r = T.getDecorators(t), "undefined" == typeof window || null === window) return u.createEmpty(r);

      if (null != e) {
        if (g.isString(e)) {
          if (g.isEmpty(e.trim())) return u.createEmpty(r);
          e = b(T.customHTML2Content(e));
        } else g.isObject(e) && null != e.toJS && (e = e.toJS());

        return n = E(e), u.createWithContent(n, r);
      }

      return u.createEmpty(r);
    },
    createContentBlock: function createContentBlock(e) {
      var t, n, r, o, l, s, c, u, h, f, m;
      return null == e && (e = {}), c = e.key, m = e.type, f = e.text, r = e.data, s = e.inlineStyles, o = e.entityData, t = {
        type: null != m ? m : "unstyled",
        text: null != f ? f : "",
        key: null != c ? c : S()
      }, r && (t.data = p.fromJS(r)), (s || o) && (l = o ? (m = o.type, u = o.mutability, r = o.data, d.create(m, u, r)) : null, h = p.OrderedSet(s || []), n = i.create({
        style: h,
        entity: l
      }), t.characterList = p.List(p.Repeat(n, f.length))), new a(t);
    },
    getSelectedBlocksList: function getSelectedBlocksList(e) {
      var t, n, r, o, i, l;
      if (n = e.getCurrentContent(), l = (r = e.getSelection()).getStartKey(), o = r.getEndKey(), n.getBlockForKey(o), i = [].concat(n.getBlockForKey(l)), l === o) return i;

      for (; null != (l !== o ? t = n.getBlockAfter(l) : void 0);) {
        i = i.concat(t), l = t.getKey();
      }

      return i;
    },
    isBlockProtected: function isBlockProtected(e) {
      return null != e && e.getData().get("_isProtected");
    },
    willAlterProtectedBlock: function willAlterProtectedBlock(e, t) {
      var n, r, o, i, l, a, s, c, u, d;
      return ("input" === t || "delete" === t || "backspace" === t || "split-block" === t || "paste" === t) && (l = e.getSelection(), c = T.isBlockProtected, l.isCollapsed() ? (i = e.getCurrentContent(), u = l.getStartKey(), n = i.getBlockForKey(u), "delete" === t || "backspace" === t ? !!c(n) || (s = 0 === (d = l.getStartOffset()), a = d === n.getLength(), s || a ? s && "backspace" === t ? null != (o = i.getBlockBefore(u)) && c(o) : !(!a || "delete" !== t) && null != (r = i.getBlockAfter(u)) && c(r) : c(n)) : c(n)) : T.getSelectedBlocksList(e).some(c));
    },
    clearAllStyles: function clearAllStyles(e) {
      var t, n, r, o, l, a, s, c, h;
      return r = e.getSelection(), n = e.getCurrentContent(), r.isCollapsed() ? e : (t = n.getBlockMap(), s = r.getStartKey(), o = r.getEndKey(), c = r.getStartOffset(), l = r.getEndOffset(), h = t.skipUntil(function (e, t) {
        return t === s;
      }).takeUntil(function (e, t) {
        return t === o;
      }).concat(p.Map([[o, t.get(o)]])).map(function (e, t) {
        var n, r, a, u;
        return a = t === s ? c : 0, r = t === o ? l : e.getLength() - 1, n = p.Range(a, r + 1), u = e.getCharacterList().map(function (e, t) {
          var r, o;
          return n.contains(t) ? ((r = e.getEntity()) && "LINK" === (null != (o = d.get(r)) ? o.get("type") : void 0) && (r = null), i.create({
            entity: r
          })) : e;
        }), "atomic" !== e.getType() && (e = e.set("type", "unstyled")), e.set("characterList", u);
      }), a = n.merge({
        blockMap: t.merge(h),
        selectionBefore: r,
        selectionAfter: r
      }), u.push(e, a));
    },
    splitBlock: function splitBlock(e) {
      var t, n, r, o;
      return r = f.splitBlock(e.getCurrentContent(), e.getSelection()), o = r.blockMap.get(r.selectionBefore.getStartKey()).getData(), t = r.selectionAfter.getStartKey(), n = r.blockMap.update(t, function (e) {
        return e.set("data", o);
      }), u.push(e, r.set("blockMap", n), "split-block");
    },
    deleteContent: function deleteContent(e, t) {
      var n, r, o, i, l, a, s, c, d, p, h, f;
      if (l = e.getCurrentContent(), a = e.getSelection(), f = a.getStartKey(), n = l.getBlockForKey(f), r = l.getBlockAfter(f), o = l.getBlockBefore(f), a.isCollapsed()) return 0 === n.getLength() || "atomic" === n.getType() ? 1 === (i = l.getBlockMap()).size ? T.flushEditorContent(e) : "delete" === t && !r || "backspace" === t && !o ? null : (d = i.filterNot(function (e) {
        return e.get("key") === f;
      }), p = l.set("blockMap", d), s = "delete" === t ? r : o, h = m.createEmpty(s.getKey()).set("hasFocus", !0), "backspace" === t && (c = s.getLength(), h = h.merge({
        anchorOffset: c,
        focusOffset: c
      })), p = p.merge({
        selectionBefore: a,
        selectionAfter: h
      }), u.push(e, p, "remove-range")) : null;
    },
    flushEditorContent: function flushEditorContent(e) {
      var t, n, r;
      return t = e.getSelection(), r = (n = s.createFromText("")).getSelectionAfter(), u.push(e, n.merge({
        selectionBefore: t,
        selectionAfter: r.set("hasFocus", !0)
      }));
    },
    insertBlockContent: function insertBlockContent(e, t) {
      var n, r, o, i;
      return n = e.getCurrentContent(), r = e.getSelection(), i = (o = f.replaceWithFragment(n, r, t.getBlockMap())).getSelectionAfter(), u.push(e, o.merge({
        selectionBefore: r,
        selectionAfter: i.set("hasFocus", !0)
      }));
    },
    insertTextContent: function insertTextContent(e, t, n) {
      var r, o, i, l, a, s, c, p, h;
      return l = null, null != n && (h = n.type, s = n.mutability, i = n.data, l = d.create(h, s, i)), r = e.getCurrentContent(), a = (o = e.getSelection()).isCollapsed() ? "insertText" : "replaceText", p = (c = f[a](r, o, t, null, l)).getSelectionAfter(), u.push(e, c.merge({
        selectionBefore: o,
        selectionAfter: p.set("hasFocus", !0)
      }));
    },
    isEditorFocused: function isEditorFocused(e) {
      return e.getSelection().getHasFocus();
    },
    html2content: function html2content(e) {
      var t;
      return t = y(e), s.createFromBlockArray(t);
    },
    customHTML2Content: function customHTML2Content(e) {
      var t, n, r;
      return e = e.replace(/(<\/?)(p|blockquote)/g, "$1section"), r = new DOMParser().parseFromString(e, "text/html"), g.union(g.toArray(r.querySelectorAll("img")), g.toArray(r.querySelectorAll("table"))).forEach(N), t = (null != (n = (t = y(r.body.innerHTML, void 0, T.getBlockRenderMap())).contentBlocks) ? n : [T.createContentBlock()]).reduce(function (e, t) {
        var n, r, o, i, l, a, s, c, u;
        return "blockquote" !== t.getType() ? e.concat(t) : (s = JSON.parse(t.getText()), i = s.contentType, u = s.type, a = s.imgId, o = s.content, null == (l = function () {
          switch (i) {
            case "image":
              return {
                type: "IMAGE",
                mutability: "IMMUTABLE",
                data: {
                  imageId: a
                }
              };

            case "gdt_table":
              return {
                type: "GDT_TABLE",
                mutability: "IMMUTABLE",
                data: {
                  type: u,
                  manualEdit: !0,
                  data: o
                }
              };

            case "dangerousHTML":
              return {
                type: "DANGEROUS_HTML",
                mutability: "IMMUTABLE",
                data: {
                  html: o
                }
              };

            default:
              return null;
          }
        }()) ? t : (r = g.extend({
          type: "atomic",
          text: " "
        }, {
          entityData: l
        }), n = T.createContentBlock(r), c = T.createContentBlock(), e.concat([n, c])));
      }, []), r = null, s.createFromBlockArray(t);
    },
    removeInlineStyle: function removeInlineStyle(e, t) {
      var n, r, o;
      return n = e.getCurrentContent(), r = e.getSelection(), o = f.removeInlineStyle(n, r, t), u.push(e, o);
    },
    updatedEntityData: function updatedEntityData(e, t) {
      return d.mergeData(e, t);
    },
    getDecorators: function getDecorators(e) {
      var t;
      return null == e && (e = []), t = [{
        strategy: T.findTextByEntityType("LINK"),
        component: h
      }], new l(t.concat(e));
    },
    getBlockStylesClassString: function getBlockStylesClassString(e) {
      return e.getIn(["data", "styles"], p.List()).reduce(function (e, t) {
        var n;
        return null != (n = r[t]) ? e.concat(n) : e;
      }, "");
    },
    toggleCustomBlockStyle: function toggleCustomBlockStyle(e, t) {
      var n, r, o, i, l, a, s;
      return r = e.getCurrentContent(), o = e.getSelection(), n = r.getBlockMap(), a = T.getSelectedBlocksList(e), i = /^TEXT_ALIGN/.test(t), s = p.OrderedMap(a.map(function (e) {
        return [e.get("key"), e.update("data", p.Map(), function (e) {
          return e.update("styles", p.List(), function (e) {
            var n;
            return i && e.contains(t) ? e : i ? (n = e.findIndex(function (e) {
              return /^TEXT_ALIGN/.test(e);
            }), e.set(n, t)) : e.contains(t) ? e.filterNot(function (e) {
              return e === t;
            }) : e.push(t);
          });
        })];
      })), l = r.merge({
        blockMap: n.merge(s),
        selectionBefore: o,
        selectionAfter: o
      }), u.push(e, l);
    },
    numberToLetter: function numberToLetter(e) {
      var t, n, r, o, i, l, a;
      return i = (e - 1).toString(26), r = 2 <= i.length ? I.call(i, 0, l = i.length - 1) : (l = 0, []), a = i[l++], (t = function () {
        var e, t, i;

        for (i = [], o = e = 0, t = r.length; e < t; o = ++e) {
          n = r[o], i.push(String.fromCharCode(96 + parseInt(n, 26)));
        }

        return i;
      }()).push(String.fromCharCode(97 + parseInt(a, 26))), t.join("");
    }
  }, e.exports = T;
}, function (e, t, n) {
  var r, o, i, l, a, s;
  i = n(0), l = (a = n(2)).func, s = a.string, r = n(30), (o = function o(e) {
    return i.createElement("button", {
      className: "inserted-table_button inserted-table_new-window-btn",
      onClick: e.onClick,
      onFocus: e.onFocus
    }, i.createElement(r, {
      className: "inserted-table-icon-svg"
    }), i.createElement("span", {
      className: "button-label"
    }, e.label));
  }).propTypes = {
    onClick: l.isRequired,
    onFocus: l,
    label: s.isRequired
  }, o.defaultProps = {
    onFocus: function onFocus(e) {
      return e.stopPropagation();
    }
  }, e.exports = o;
}, function (e, t) {
  var n, r;
  r = {
    INLINE: "INLINE",
    BLOCK: "BLOCK",
    LINK: "LINK"
  }, n = {
    BOLD: "IN_BOLD",
    ITALIC: "IN_ITAL",
    UNDERLINE: "IN_UNDER",
    FONT_SIZE: "IN_FSIZE",
    FONT_SIZE_SMALL: "IN_FSIZE_SMALL",
    FONT_SIZE_MODERATE: "IN_FSIZE_MODERATE",
    FONT_SIZE_NORMAL: "IN_FSIZE_NORM",
    FONT_SIZE_LARGE: "IN_FSIZE_LRG",
    FONT_SIZE_HUGE: "IN_FSIZE_HUGE",
    UNORDERED_LIST: "BL_UL",
    ALIGNMENT: "BL_ALIGN",
    ALIGNMENT_LEFT: "BL_ALIGN_LT",
    ALIGNMENT_CENTER: "BL_ALIGN_CNTR",
    ALIGNMENT_RIGHT: "BL_ALIGN_RT",
    LINK: "LINK",
    CUSTOM: "CUSTOM",
    CLEAR_FORMATING: "IN_CLEARF"
  }, e.exports = {
    controlNames: n,
    controlTypes: r
  };
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u, d, p;
  l = n(0), s = n(1), u = (d = n(2)).object, p = d.string, c = d.func, a = n(28), o = n(12), i = n(9), r = s({
    displayName: "CollapsedInsertedGdtTable",
    propTypes: {
      tableData: u.isRequired,
      outcomesText: p.isRequired,
      tableTitle: p.isRequired,
      onToggle: c.isRequired,
      openInNewWindow: c.isRequired,
      expandTitle: p.isRequired,
      openInNewWindowTitle: p.isRequired
    },
    render: function render() {
      return l.createElement("div", null, l.createElement("div", {
        className: "inserted-table_icon"
      }, l.createElement("span", {
        className: "icon"
      }, l.createElement(a, {
        className: "inserted-table-icon-svg"
      })), l.createElement("span", {
        className: "buttons"
      }, l.createElement(o, {
        onClick: this.props.onToggle,
        label: this.props.expandTitle
      }), l.createElement(i, {
        onClick: this.props.openInNewWindow,
        label: this.props.openInNewWindowTitle
      }))), l.createElement("div", {
        className: "inserted-table_title",
        dangerouslySetInnerHTML: {
          __html: this.props.tableTitle
        }
      }), l.createElement("div", {
        className: "inserted-table_outcomes"
      }, this.props.outcomesText));
    }
  }), e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a, s;
  i = n(0), l = (a = n(2)).func, s = a.string, r = n(29), (o = function o(e) {
    return i.createElement("button", {
      className: "inserted-table_button inserted-table_expand-btn",
      onClick: e.onClick,
      onFocus: e.onFocus
    }, i.createElement(r, {
      className: "inserted-table-icon-svg"
    }), i.createElement("span", {
      className: "button-label"
    }, e.label));
  }).propTypes = {
    onClick: l.isRequired,
    onFocus: l,
    label: s.isRequired
  }, o.defaultProps = {
    onFocus: function onFocus(e) {
      return e.stopPropagation();
    }
  }, e.exports = o;
}, function (e, t, n) {
  var r, o, i, l, a, s;
  i = n(0), l = (a = n(2)).func, s = a.string, r = n(31), (o = function o(e) {
    return i.createElement("button", {
      className: "inserted-table_button inserted-table_collapse-btn",
      onClick: e.onClick,
      onFocus: e.onFocus
    }, i.createElement(r, {
      className: "inserted-table-icon-svg"
    }), i.createElement("span", {
      className: "button-label"
    }, e.label));
  }).propTypes = {
    label: s.isRequired,
    onClick: l.isRequired,
    onFocus: l
  }, o.defaultProps = {
    onFocus: function onFocus(e) {
      return e.stopPropagation();
    }
  }, e.exports = o;
}, function (e, t, n) {
  var r, o, i;
  i = n(0), o = n(4).Entity, r = function r(e) {
    var t;
    return t = o.get(e.block.getEntityAt(0)).getData().html, i.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: t
      }
    });
  }, e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u, d;
  i = n(0), a = n(1), u = n(2).object, l = n(3), o = n(5), c = {
    backgroundColor: "#ebebeb",
    color: "#000"
  }, s = l.extend({
    fontWeight: "bold"
  }, c), d = {
    bold: {
      fontWeight: "bold"
    },
    table: {
      tableLayout: "fixed",
      width: "100%",
      margin: "initial",
      borderCollapse: "collapse",
      fontSize: "8pt",
      fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif"
    },
    cell: {
      border: "1px solid #bfbfbf"
    },
    thead: {
      fontSize: "8pt",
      backgroundColor: "#d2dfed"
    },
    thOutcome: {
      width: "initial"
    },
    tdQuality: {
      textAlign: "center"
    },
    tbody: {
      textAlign: "left"
    },
    tdAbsDiff: c,
    prevalencesDesc: c,
    disabledImportance: c,
    diagOutcomeAD: s
  }, r = a({
    displayName: "DxEvidenceTable",
    propTypes: {
      data: u.isRequired,
      style: u
    },
    render: function render() {
      return i.createElement(o, {
        data: this.props.data,
        style: l.extend({}, d, this.props.style || {})
      });
    }
  }), e.exports = r;
}, function (e, t, n) {
  var r, o, i, _l;

  i = n(3), o = n(7), _l = function l(e, t) {
    var n, r, a, s;
    if (null == e || null == t) return !1;
    if (e === t) return !0;

    for (n in e) {
      if (r = e[n], e.hasOwnProperty(n) && !t.hasOwnProperty(n)) return !1;
      if (!(r === (s = t[n]) || (o.Iterable.isIterable(r) && o.Iterable.isIterable(s) ? r.equals(s) : !(!i.isObject(r) || !i.isObject(s)) && _l(r, s)))) return !1;
    }

    for (a in t) {
      if (t.hasOwnProperty(a) && !e.hasOwnProperty(a)) return !1;
    }

    return !0;
  }, r = {
    shouldComponentUpdate: function shouldComponentUpdate(e, t) {
      return !_l(e, this.props) || !_l(t, this.state);
    }
  }, e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u, d, p, h, f, m, g, y, E, b, C, N, T, S, v, L, k, I, A, _, x, B, w;

  m = n(0), N = n(1), E = (_ = n(2)).bool, k = _.object, L = _.instanceOf, w = _.string, A = _.oneOfType, v = _.func, y = _.arrayOf, B = _.shape, S = _.element, I = _.objectOf, l = n(4), h = n(7), s = n(35), u = n(21), i = n(14), f = n(36), T = n(8), b = (x = n(10)).controlNames, x.controlTypes, a = l.Editor, c = l.EditorState, l.ContentState, d = l.Entity, g = l.RichUtils, r = l.AtomicBlockUtils, C = l.convertToRaw, l.convertFromHTML, o = [b.BOLD, b.ITALIC, b.UNDERLINE, b.FONT_SIZE, b.UNORDERED_LIST, b.ALIGNMENT, b.LINK, b.CUSTOM, b.CLEAR_FORMATING], p = N({
    displayName: "Editor",
    propTypes: {
      readOnly: E,
      editorContent: A([k, w]),
      attachments: L(h.Map),
      saveAttachment: v,
      onFocus: v,
      onBlur: v,
      onChange: v,
      getEmbeddedImageSrc: v,
      controlsAutoHide: E,
      stickControlsTo: w,
      customControls: y(k),
      customEntityRenderers: I(v),
      customBlockRenderers: I(v),
      customBlockMapEntries: I(B({
        element: w.isRequired,
        wrapper: S
      })),
      customHandlers: I(v),
      customDecorators: A([B({
        strategy: v.isRequired,
        component: v.isRequired,
        props: k
      }), y(B({
        strategy: v.isRequired,
        component: v.isRequired,
        props: k
      }))]),
      placeholder: w,
      controlsOrder: y(w)
    },
    getInitialState: function getInitialState() {
      return {
        editorState: T.getEditorState(this.props.editorContent, this.props.customDecorators),
        isEditing: !1,
        keepEditorActive: !1
      };
    },
    getDefaultProps: function getDefaultProps() {
      return {
        customEntityRenderers: {},
        customBlockRenderers: {},
        customBlockMapEntries: {},
        customHandlers: {},
        controlsAutoHide: !0,
        attachments: h.Map(),
        placeholder: null,
        controlsOrder: o
      };
    },
    focus: function focus() {
      return this.editor.focus();
    },
    keepEditorActive: function keepEditorActive() {
      return this.setState({
        keepEditorActive: !0
      });
    },
    _onChange: function _onChange(e) {
      var t;
      return this.setState({
        editorState: e
      }), "function" == typeof (t = this.props).onChange ? t.onChange(e) : void 0;
    },
    onEditorFocus: function onEditorFocus() {
      var e;
      return this.setState({
        isEditing: !0,
        keepEditorActive: !1
      }), "function" == typeof (e = this.props).onFocus ? e.onFocus() : void 0;
    },
    onEditorBlur: function onEditorBlur(e) {
      var t;
      if (!this.state.keepEditorActive) return this.setState({
        isEditing: !1,
        keepEditorActive: !1
      }), "function" == typeof (t = this.props).onBlur ? t.onBlur(e) : void 0;
    },
    getEmbeddedImageSrc: function getEmbeddedImageSrc(e) {
      var t, n;
      return (t = this.props.attachments.get(e)) ? "data:" + (n = t.toJS()).content_type + ";base64," + n.data : null;
    },
    _insertAttachment: function _insertAttachment(e) {
      var t;
      if (/^image\//.test(e.type)) return t = this.props.saveAttachment(e), this.insertCustomBlock({
        type: "IMAGE",
        mutability: "IMMUTABLE",
        data: {
          imageId: t
        }
      });
    },
    insertCustomBlock: function insertCustomBlock(e) {
      var t, n, o, i, l;
      return l = e.type, i = e.mutability, t = e.data, n = this.state.editorState, o = d.create(l, i, t), this._onChange(r.insertAtomicBlock(n, o, " "));
    },
    insertText: function insertText(e, t) {
      var n;
      return this.focus(), n = this.state.editorState, this._onChange(T.insertTextContent(n, e, t));
    },
    _insertLink: function _insertLink(e) {
      var t, n;
      return this.hideLinkInsert(), this.focus(), t = this.state.editorState, n = d.create("LINK", "MUTABLE", {
        url: e
      }), this._onChange(g.toggleLink(t, t.getSelection(), n));
    },
    insertContent: function insertContent(e) {
      var t, n, r, o;

      switch (r = e.contentType, t = e.content, o = e.file, this.focus(), r) {
        case "ATTACHMENT":
          return this._insertAttachment(o);

        case "HTML":
          return n = T.html2content(t), this._onChange(T.insertBlockContent(this.state.editorState, n));
      }
    },
    updateEntityData: function updateEntityData(e, t) {
      return this.focus(), T.updatedEntityData(e, t);
    },
    toggleStyle: function toggleStyle(e) {
      var t, n;

      switch (n = e.type, t = e.style, n) {
        case "INLINE":
          return this.toggleInlineStyle(t);

        case "BLOCK":
          return this.toggleBlockStyle(t);

        case "LINK":
          return this.toggleLink();
      }
    },
    toggleLink: function toggleLink() {
      var e;
      return e = this.state.editorState, g.currentBlockContainsLink(e) ? this._onChange(g.toggleLink(e, e.getSelection(), null)) : this.setState({
        showLinkInsert: !0
      });
    },
    toggleInlineStyle: function toggleInlineStyle(e) {
      var t, n, r, o;
      return r = this.state.editorState, "CLEAR_ALL" === e ? this._onChange(T.clearAllStyles(r)) : (n = r.getCurrentInlineStyle(), (o = /_FONT$/.test(e)) && n.has(e) ? void 0 : (o && null != (t = n.find(function (e) {
        return /_FONT$/.test(e);
      })) && (r = T.removeInlineStyle(r, t)), this._onChange(g.toggleInlineStyle(r, e))));
    },
    toggleBlockStyle: function toggleBlockStyle(e) {
      return this._onChange(e in T.CUSTOM_BLOCK_STYLES_CLASS_MAP ? T.toggleCustomBlockStyle(this.state.editorState, e) : g.toggleBlockType(this.state.editorState, e));
    },
    hideLinkInsert: function hideLinkInsert() {
      return this.setState({
        showLinkInsert: !1
      }, this.focus);
    },
    blockRendererFn: function blockRendererFn(e) {
      var t, n, r, o, l, a, s;

      if (l = null != (s = this.props.getEmbeddedImageSrc) ? s : this.getEmbeddedImageSrc, "atomic" === (t = e.getType())) {
        if (null == (r = e.getEntityAt(0))) return;
        if ("IMAGE" === (o = (n = d.get(r)).getType())) return a = n.getData().imageId, {
          component: u,
          editable: !1,
          props: {
            src: l(a),
            imageId: a
          }
        };
        if ("DANGEROUS_HTML" === o) return {
          component: i,
          editable: !1
        };
        if (o in this.props.customEntityRenderers) return (0, this.props.customEntityRenderers[o])(this, e);
      } else if (t in this.props.customBlockRenderers) return (0, this.props.customBlockRenderers[t])(this, e);
    },
    blockStyleFn: T.getBlockStylesClassString,
    handleBeforeInput: function handleBeforeInput(e) {
      var t, n, r;
      if (n = this.state.editorState, null != (t = this.props.customHandlers.handleBeforeInput) && null != (r = t(n, e))) return this._onChange(r), "handled";
    },
    handleKeyCommand: function handleKeyCommand(e) {
      var t, n, r, o;
      return n = this.state.editorState, null != (t = this.props.customHandlers.handleKeyCommand) ? null != (r = t(n, e)) ? (this._onChange(r), "handled") : "not-handled" : "split-block" === e ? (this._onChange(T.splitBlock(n)), "handled") : "backspace" !== e && "delete" !== e || !(o = T.deleteContent(n, e)) ? "not-handled" : (this._onChange(o), "handled");
    },
    handlePastedText: function handlePastedText(e, t) {
      var n, r, o, i;
      return o = this.state.editorState, null != (r = this.props.customHandlers.handlePastedText) && null != (i = r(o, e, t)) ? (this._onChange(i), "handled") : null != e && null == t ? "not-handled" : (n = T.html2content(t), this._onChange(T.insertBlockContent(o, n)), "handled");
    },
    triggerBlocksRerender: function triggerBlocksRerender() {
      var e;
      return e = this.state.editorState.getSelection(), this._onChange(c.forceSelection(this.state.editorState, e.set("hasFocus", !0)));
    },
    componentDidUpdate: function componentDidUpdate(e, t) {
      if (!e.attachments.equals(this.props.attachments) && this.state.isEditing) return this.triggerBlocksRerender();
    },
    resetContent: function resetContent(e) {
      return this.setState({
        editorState: T.getEditorState(e, this.props.customDecorators),
        isEditing: !1
      });
    },
    getEditorContent: function getEditorContent() {
      return h.fromJS(C(this.state.editorState.getCurrentContent()));
    },
    render: function render() {
      var e, t;
      return e = ["gdt-editor-container"], e = this.state.isEditing ? e.concat("editing") : this.props.readOnly ? e.concat("readonly") : e, m.createElement("div", {
        className: e.join(" ")
      }, this.state.isEditing || !this.props.controlsAutoHide ? m.createElement("div", null, m.createElement(s, {
        editorState: this.state.editorState,
        customControls: this.props.customControls,
        stickTo: this.props.stickControlsTo,
        onToggle: this.toggleStyle,
        controlsOrder: this.props.controlsOrder
      })) : void 0, m.createElement(a, {
        ref: (t = this, function (e) {
          return t.editor = e;
        }),
        readOnly: this.props.readOnly,
        onChange: this._onChange,
        onFocus: this.onEditorFocus,
        onBlur: this.onEditorBlur,
        editorState: this.state.editorState,
        blockRenderMap: T.getBlockRenderMap(this.props.customBlockMapEntries),
        blockRendererFn: this.blockRendererFn,
        blockStyleFn: this.blockStyleFn,
        customStyleMap: T.CUSTOM_STYLE_MAP,
        handleBeforeInput: this.handleBeforeInput,
        handlePastedText: this.handlePastedText,
        handleKeyCommand: this.handleKeyCommand,
        suppressContentEditableWarning: !0,
        placeholder: this.props.placeholder
      }), this.state.showLinkInsert ? m.createElement(f, {
        onClose: this.hideLinkInsert,
        onSubmit: this._insertLink
      }) : void 0);
    }
  }), e.exports = p;
}, function (e, t) {
  e.exports = require("react-dom");
}, function (e, t) {
  e.exports = require("classnames");
}, function (e, t, n) {
  var r, o;
  r = n(0), o = n(1)({
    displayName: "TooltipWrapperComponent",
    mixins: [n(16)],
    _elWithTooltip: function _elWithTooltip() {
      return $(this.refs.tooltipEl);
    },
    _initTooltips: function _initTooltips() {
      var e;
      return null != (e = this.props.mediator) ? e.tooltips.info(this._elWithTooltip(), {
        cache: !1
      }) : void 0;
    },
    _unmountTooltips: function _unmountTooltips() {
      var e;
      return null != (e = this.props.mediator) ? e.tooltips.deactivateTooltip(this._elWithTooltip()) : void 0;
    },
    componentDidMount: function componentDidMount() {
      return this._initTooltips();
    },
    componentWillUpdate: function componentWillUpdate(e, t) {
      return this._unmountTooltips();
    },
    componentDidUpdate: function componentDidUpdate(e, t) {
      return this._initTooltips();
    },
    componentWillUnmount: function componentWillUnmount() {
      return this._unmountTooltips();
    },
    render: function render() {
      return r.cloneElement(r.Children.only(this.props.children), {
        ref: "tooltipEl"
      });
    }
  }), e.exports = o;
}, function (e, t, n) {
  var r, o;
  o = n(0), r = function r(e) {
    var t, n, r;
    return r = (n = e.blockProps).src, t = n.imageId, r ? o.createElement("img", {
      src: r,
      style: {
        width: "100%"
      },
      "db-image": t
    }) : o.createElement("i", null, "Loading...");
  }, e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u;
  i = n(0), s = n(1), c = n(2).object, l = n(3), a = {
    fontWeight: "bold"
  }, o = n(5), u = {
    table: {
      width: "100%",
      border: "1px solid #bfbfbf",
      borderCollapse: "collapse",
      fontSize: "8pt",
      fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif",
      padding: "5px"
    },
    thead: {
      backgroundColor: "#275C99",
      color: "#fff",
      borderTop: "2px solid #000",
      borderBottom: "2px solid #000",
      fontSize: "8pt"
    },
    cell: {
      border: "1px solid #bfbfbf"
    },
    thResultsPer1000: {
      backgroundColor: "#95B3D7",
      color: "#000",
      fontWeight: "bold",
      borderBottom: "1px solid #000"
    },
    thQuality: a,
    thNoOfParticipantsStudiesDiagnostic: a,
    thTestResult: a,
    thIndexTest: {
      backgroundColor: "#B8CCE4",
      color: "#000"
    },
    thComparatorTest: {
      backgroundColor: "#B8CCE4",
      color: "#000"
    },
    thPrevalence: {
      backgroundColor: "#B8CCE4",
      color: "#000",
      borderLeft: "1px solid #000",
      borderRight: "1px solid #000",
      borderBottom: "1px solid #000"
    },
    tdPrevalence: {
      backgroundColor: "#DBE5F1"
    },
    tdPrevalenceTextCell: {
      textAlign: "left",
      backgroundColor: "#DBE5F1"
    }
  }, r = s({
    displayName: "LayerOneTwoSof",
    propTypes: {
      data: c.isRequired,
      style: c
    },
    render: function render() {
      return i.createElement(o, {
        data: this.props.data,
        style: l.extend({}, u, this.props.style || {})
      });
    }
  }), e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a, s, c;
  o = n(0), a = n(1), s = n(2).object, r = n(5), l = n(3), c = {
    bold: {
      fontWeight: "bold"
    },
    table: {
      tableLayout: "fixed",
      width: "100%",
      margin: "initial",
      borderCollapse: "collapse",
      fontSize: "8pt",
      fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif",
      textAlign: "center"
    },
    cell: {
      border: "1px solid #bfbfbf"
    },
    thead: {
      fontSize: "8pt",
      backgroundColor: "#e9e9e9"
    }
  }, i = a({
    displayName: "RelativeImportance",
    propTypes: {
      data: s.isRequired,
      style: s
    },
    render: function render() {
      return o.createElement(r, {
        data: this.props.data,
        style: l.extend({}, c, this.props.style || {})
      });
    }
  }), e.exports = i;
}, function (e, t, n) {
  var r, o, i, l, a, s, c;
  o = n(0), a = n(1), s = n(2).object, l = n(3), r = n(5), c = {
    bold: {
      fontWeight: "bold"
    },
    table: {
      tableLayout: "fixed",
      width: "100%",
      margin: "initial",
      borderCollapse: "collapse",
      fontSize: "8pt",
      fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif",
      textAlign: "center"
    },
    cell: {
      border: "1px solid #bfbfbf"
    },
    thCell: {
      height: "75px"
    },
    thead: {
      fontSize: "8pt",
      backgroundColor: "#e9e9e9"
    },
    outcome: {
      width: "25%"
    }
  }, i = a({
    displayName: "SofShortTable",
    propTypes: {
      data: s.isRequired,
      style: s
    },
    render: function render() {
      return o.createElement(r, {
        data: this.props.data,
        style: l.extend({}, c, this.props.style || {})
      });
    }
  }), e.exports = i;
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u, d;
  o = n(0), a = n(1), u = n(2).object, l = n(3), r = n(5), c = {
    backgroundColor: "#ebebeb",
    color: "#000"
  }, s = l.extend({
    fontWeight: "bold"
  }, c), d = {
    table: {
      tableLayout: "fixed",
      width: "100%",
      margin: "initial",
      borderCollapse: "collapse",
      borderTop: "2px solid black",
      borderBottom: "2px solid black",
      fontSize: "8pt",
      fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif"
    },
    thead: {
      backgroundColor: "#3271aa",
      color: "#fff",
      textAlign: "left",
      verticalAlign: "top",
      borderBottom: "2px solid black",
      fontSize: "8pt"
    },
    cell: {
      textAlign: "left",
      verticalAlign: "top",
      padding: "5px",
      fontSize: "8pt",
      border: "1px solid #bfbfbf"
    },
    absoluteEffect: s,
    without: s,
    with: s,
    difference: s,
    riskWith: s,
    riksDifferenceWith: s,
    controlLabel: c,
    dichCorrespondingRisk: c,
    impact: c,
    dichSofControl: c,
    dichSofControlLow: c,
    dichSofControlMedium: c,
    dichSofControlHigh: c,
    contSofControl: c,
    contRiskDifference: c,
    dichRiskDifference: c,
    contCorrespondingRisk: c
  }, i = a({
    displayName: "SofTable",
    propTypes: {
      data: u.isRequired,
      style: u
    },
    render: function render() {
      return o.createElement(r, {
        data: this.props.data,
        style: l.extend({}, d, this.props.style || {})
      });
    }
  }), e.exports = i;
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u, d, p, h, f, m, g, y, E, b, C, N;
  N = n(27).version, o = n(11), r = n(13), i = n(14), l = n(15), a = n(17), c = n(38), s = n(8), u = n(21), d = n(12), p = n(41), h = n(22), m = n(5), f = n(9), y = n(23), E = n(24), b = n(25), g = n(42), C = n(10).controlNames, n(43), e.exports = {
    CollapsedInsertedGdtTable: o,
    CollapseTableButton: r,
    DangerousContainer: i,
    DxEvidenceTable: l,
    Editor: a,
    EditorWithApply: c,
    EditorUtils: s,
    ExpandTableButton: d,
    InsertedGdtTable: p,
    LayerOneTwoSof: h,
    OutcomeTable: m,
    OpenInNewWindowButton: f,
    RelativeImportance: y,
    SofTable: b,
    SofShort: E,
    EmbeddedImageComponent: u,
    ReferenceCitation: g,
    version: N,
    builtInStyleControls: C
  };
}, function (e) {
  e.exports = {
    name: "@ep/editor",
    version: "0.4.7",
    description: "Editor for gradepro application",
    main: "src/index.cjsx",
    scripts: {
      "build:prod": "NODE_ENV=production webpack",
      "build:umd:prod": "NODE_ENV=production webpack --config scripts/umd.webpack.config",
      "build:copy-files": "node ./scripts/copy-build-files.js",
      prebuild: "rm -rf ./dist",
      build: "yarn build:prod && yarn build:umd:prod && yarn build:copy-files",
      release: "yarn build && npm publish dist",
      start: "cross-env NODE_ENV=development webpack-dev-server --progress --colors",
      test: 'echo "Error: no test specified" && exit 1'
    },
    author: "",
    license: "ISC",
    devDependencies: {
      "cjsx-loader": "^3.0.0",
      classnames: "^2.2.6",
      "coffee-loader": "^0.7.2",
      "coffee-script": "^1.12.2",
      "copy-webpack-plugin": "^4.5.2",
      "create-react-class": "^15.6.3",
      "cross-env": "^5.2.0",
      "css-loader": "^1.0.0",
      "draft-js": "^0.10.5",
      "fs-extra": "^5.0.0",
      "html-webpack-plugin": "^3.2.0",
      i18next: "^11.1.1",
      "i18next-xhr-backend": "^1.5.1",
      immutable: "^3.8.1",
      jquery: "^3.3.1",
      "jsx-loader": "^0.13.2",
      "mini-css-extract-plugin": "^0.4.2",
      "prop-types": "^15.6.2",
      react: "^15.6.2",
      "react-addons-create-fragment": "^15.6.2",
      "react-dom": "15.6.2",
      "style-loader": "^0.23.0",
      stylus: "^0.54.5",
      "stylus-loader": "^3.0.2",
      "svg-react-loader": "^0.4.5",
      underscore: "^1.9.1",
      "underscore.string": "^3.3.4",
      webpack: "^4.18.0",
      "webpack-cli": "^3.1.0",
      "webpack-dev-server": "^3.1.8"
    },
    peerDependencies: {
      classnames: "*",
      "create-react-class": "^15.6.3",
      "draft-js": "^0.10.5",
      "prop-types": "*",
      react: "*",
      "react-dom": "*",
      "react-addons-create-fragment": "^15.6.2",
      underscore: "^1.9.1",
      "underscore.string": "^3.3.4"
    }
  };
}, function (e, t, n) {
  var r = n(0);

  function o(e) {
    return r.createElement("svg", e, [r.createElement("defs", {
      key: 0
    }, r.createElement("style", null, ".editorcls-1{isolation:isolate;}.editorcls-2{opacity:0.3;mix-blend-mode:multiply;}.editorcls-3{fill:#fff;}.editorcls-4{fill:none;stroke:#2990e2;stroke-miterlimit:10;}.editorcls-5{fill:#3271aa;}.editorcls-6{fill:#f2f2f2;}.editorcls-7{fill:#ddd;}")), r.createElement("title", {
      key: 1
    }, "table minature"), r.createElement("g", {
      className: "editorcls-1",
      key: 2
    }, r.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2"
    }, r.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    }, [r.createElement("image", {
      className: "editorcls-2",
      width: "109",
      height: "84",
      xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAABUCAYAAACIjbkzAAAACXBIWXMAAAsSAAALEgHS3X78AAADPUlEQVR4Xu2dwW7TQBRFzyRpG9pSqAosEEgs+P+vQkCpKE1pQ0kam8WbF4+NU1jYVZ90jzSKYzubObrjcTY31XWNiMXkXzeIp8ds14WUUvLDXfeI0agB6h3LYOqez7ISlsJJPvYhxqXOo8qjxty1JLWkpZRc1BTYy2OWv0vcuLisDXAPrPLnBqhKcdvlMSdsgomaA4fAEfAsn3NxYng8YS5rCdzkz1VxHWg/0xImZg6cAK+As3w8x8QpbeNQY4laYbJ+AN/ytQrYpJSSp20Gf6XsCBP2AXgPvAGeAwdotzkWnrJb4BL4jIWjXCYrv7lMWintDBP2EXgLvMCkTRFjUGNyfgJf87nvWOKuaVa4JmnFyRnN8vgaE/YOOEXSxqTCpC3y9wVwDOzTs5foe6btYZuPEyxhp3nM0fI4FhXwOx9fY6vdAebHX7u2dKW5uBlm+SCPOXqmjYk/r/ZpXrPK9+QW3X9EyhfraTEmxRDjUM7xg7t0SQiIpAVE0gIiaQGRtIBIWkAkLSCSFhBJC4ikBUTSAiJpAZG0gEhaQCQtIJIWEEkLiKQFRNICImkBkbSASFpAJC0gkhYQSQuIpAVE0gIiaQGRtIBIWkAkLSCSFhBJC4ikBUTSAiJpAZG0gEhaQCQtIJIWEEkLiKQFRNICImkBkbSASFpAJC0gkhYQSQuIpAVE0gIiaQGRtIBIWkAkLSCSFhBJC4ikBUTSArJLWt0Z4nH4r3nvFgSVza+bniHGoW+uywbeFqW0sv11DdxhRaK/8gBLpjpBh8Xn3ed5ic39mkZeS1yftBXWTXmF9VMe5+vzfL+kDYv3gd5hlZKX2NzfYi52SvM1dI3ZXgDnWGMeWFflIZI2Bi5tiXWAfsLmfoG5WPNAZbIvizfABZYs76l8SSNNO85hqWikXQFfsPbdC8yFL5NbZmA98yklT9oSiyhYwjxxXuSqruvh8ARtsE5Qfyz5o2lJTlpvo3znxx7Zm/xj76rURmR4fC+xpmmT9w3gCnPSeqalQmBZUj7BhHqpaNkCK2nD4mnzZfIeE+iF5FWZMuhIg604aCSVsiRsHMoX6qr4pCsMeqS1LjYCJetxqKFfVMmD0sTT5A87WQB8KLDuEAAAAABJRU5ErkJggg==",
      key: 0
    }), r.createElement("rect", {
      className: "editorcls-3",
      x: "3.52",
      y: "4.42",
      width: "95.17",
      height: "69.62",
      rx: "1.86",
      ry: "1.86",
      key: 1
    }), r.createElement("rect", {
      className: "editorcls-4",
      x: "3.52",
      y: "4.42",
      width: "95.17",
      height: "69.62",
      rx: "1.86",
      ry: "1.86",
      key: 2
    }), r.createElement("rect", {
      className: "editorcls-5",
      x: "8.31",
      y: "14.82",
      width: "85.58",
      height: "4.72",
      key: 3
    }), r.createElement("rect", {
      className: "editorcls-5",
      x: "8.31",
      y: "33.44",
      width: "85.58",
      height: "4.72",
      key: 4
    }), r.createElement("rect", {
      className: "editorcls-6",
      x: "8.31",
      y: "20.89",
      width: "20.85",
      height: "11.46",
      key: 5
    }), r.createElement("rect", {
      className: "editorcls-7",
      x: "29.89",
      y: "20.89",
      width: "20.85",
      height: "11.46",
      key: 6
    }), r.createElement("rect", {
      className: "editorcls-7",
      x: "51.47",
      y: "20.89",
      width: "20.85",
      height: "11.46",
      key: 7
    }), r.createElement("rect", {
      className: "editorcls-6",
      x: "73.04",
      y: "20.89",
      width: "20.85",
      height: "11.46",
      key: 8
    }), r.createElement("rect", {
      className: "editorcls-5",
      x: "8.31",
      y: "51.69",
      width: "85.58",
      height: "4.72",
      key: 9
    }), r.createElement("rect", {
      className: "editorcls-6",
      x: "8.31",
      y: "57.76",
      width: "20.85",
      height: "11.46",
      key: 10
    }), r.createElement("rect", {
      className: "editorcls-7",
      x: "29.89",
      y: "57.76",
      width: "20.85",
      height: "11.46",
      key: 11
    }), r.createElement("rect", {
      className: "editorcls-7",
      x: "51.47",
      y: "57.76",
      width: "20.85",
      height: "11.46",
      key: 12
    }), r.createElement("rect", {
      className: "editorcls-6",
      x: "73.04",
      y: "57.76",
      width: "20.85",
      height: "11.46",
      key: 13
    }), r.createElement("rect", {
      className: "editorcls-6",
      x: "8.31",
      y: "39.32",
      width: "20.85",
      height: "11.46",
      key: 14
    }), r.createElement("rect", {
      className: "editorcls-7",
      x: "29.89",
      y: "39.32",
      width: "20.85",
      height: "11.46",
      key: 15
    }), r.createElement("rect", {
      className: "editorcls-7",
      x: "51.47",
      y: "39.32",
      width: "20.85",
      height: "11.46",
      key: 16
    }), r.createElement("rect", {
      className: "editorcls-6",
      x: "73.04",
      y: "39.32",
      width: "20.85",
      height: "11.46",
      key: 17
    })])))]);
  }

  o.displayName = "TableMiniature", o.defaultProps = {
    viewBox: "0 0 109 84"
  }, e.exports = o, o.default = o;
}, function (e, t, n) {
  var r = n(0);

  function o(e) {
    return r.createElement("svg", e, [r.createElement("defs", {
      key: 0
    }, r.createElement("style", null, ".editorcls-1{fill:#3783a5;}")), r.createElement("title", {
      key: 1
    }, "expand"), r.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2",
      key: 2
    }, r.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    }, r.createElement("path", {
      className: "editorcls-1",
      d: "M12.09,8.93l-.89.89L8.35,7,11.2,4.13l.89.9a.66.66,0,0,0,1.11-.34L13.94.78A.65.65,0,0,0,13.18,0L9.27.76a.65.65,0,0,0-.34,1.1l.89.9L7,5.6,4.13,2.76l.9-.9A.65.65,0,0,0,4.69.76L.78,0A.66.66,0,0,0,0,.78L.76,4.69A.65.65,0,0,0,1.86,5l.9-.9L5.6,7,2.76,9.82l-.9-.89a.65.65,0,0,0-1.1.34L0,13.18a.65.65,0,0,0,.77.76l3.91-.74A.66.66,0,0,0,5,12.09l-.9-.89L7,8.35,9.82,11.2l-.89.89a.66.66,0,0,0,.34,1.11l3.91.74a.65.65,0,0,0,.76-.76L13.2,9.27A.66.66,0,0,0,12.09,8.93Z"
    })))]);
  }

  o.displayName = "ExpandTable", o.defaultProps = {
    viewBox: "0 0 13.96 13.96"
  }, e.exports = o, o.default = o;
}, function (e, t, n) {
  var r = n(0);

  function o(e) {
    return r.createElement("svg", e, [r.createElement("defs", {
      key: 0
    }, r.createElement("style", null, ".editorcls-1{fill:#3783a5;}")), r.createElement("title", {
      key: 1
    }, "open in window"), r.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2",
      key: 2
    }, r.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    }, [r.createElement("path", {
      className: "editorcls-1",
      d: "M15.6,0,8.77.2a.55.55,0,0,0-.39.92l1.47,1.6L5.72,6.54,9,10.05,13.1,6.22l1.39,1.5a.55.55,0,0,0,.95-.32L16.16.61A.55.55,0,0,0,15.6,0Z",
      key: 0
    }), r.createElement("path", {
      className: "editorcls-1",
      d: "M13.4,12.3a1.16,1.16,0,0,1-1.16,1.16H2.33a1,1,0,0,1-1-1V3.2A1.25,1.25,0,0,1,2.56,2H6.64V.71H2.08A2.08,2.08,0,0,0,0,2.79v9.83A2.08,2.08,0,0,0,2.08,14.7H12.62a2.08,2.08,0,0,0,2.08-2.08V9.9H13.4Z",
      key: 1
    })]))]);
  }

  o.displayName = "OpenInWindow", o.defaultProps = {
    viewBox: "0 0 16.16 14.7"
  }, e.exports = o, o.default = o;
}, function (e, t, n) {
  var r = n(0);

  function o(e) {
    return r.createElement("svg", e, [r.createElement("defs", {
      key: 0
    }, r.createElement("style", null, ".editorcls-1{fill:#3783a5;}")), r.createElement("title", {
      key: 1
    }, "collapse"), r.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2",
      key: 2
    }, r.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    }, [r.createElement("path", {
      className: "editorcls-1",
      d: "M15.36,6a0,0,0,0,0,0-.06L13.66,4.22l2.85-2.85L15.13,0,12.29,2.85,10.57,1.12a0,0,0,0,0-.07,0l-1.13,6a0,0,0,0,0,0,0Z",
      key: 0
    }), r.createElement("path", {
      className: "editorcls-1",
      d: "M1.14,11a0,0,0,0,0,0,.06L2.85,12.8,0,15.65,1.37,17l2.85-2.85,1.72,1.72a0,0,0,0,0,.06,0L7.14,9.93a0,0,0,0,0,0,0Z",
      key: 1
    }), r.createElement("path", {
      className: "editorcls-1",
      d: "M15.38,11.08a0,0,0,0,0,0-.06L9.41,9.88a0,0,0,0,0,0,0l1.13,5.94a0,0,0,0,0,.07,0l1.72-1.72L15.13,17l1.38-1.37L13.66,12.8Z",
      key: 2
    }), r.createElement("path", {
      className: "editorcls-1",
      d: "M5.94,1.12,4.22,2.85,1.37,0,0,1.37,2.85,4.22,1.12,5.94a0,0,0,0,0,0,.06l6,1.14a0,0,0,0,0,0,0L6,1.14A0,0,0,0,0,5.94,1.12Z",
      key: 3
    })]))]);
  }

  o.displayName = "CollapseTable", o.defaultProps = {
    viewBox: "0 0 16.51 17.02"
  }, e.exports = o, o.default = o;
}, function (e, t) {
  e.exports = require("underscore.string");
}, function (e, t) {
  e.exports = require("react-addons-create-fragment");
}, function (e, t, n) {
  var r, o, i;
  i = n(0), r = n(4).Entity, o = function o(e) {
    var t;
    return t = r.get(e.entityKey).getData().url, i.createElement("a", {
      href: t,
      style: {
        cursor: "pointer",
        textDecoration: "none"
      }
    }, e.children);
  }, e.exports = o;
}, function (e, t, n) {
  var _ref;

  var r, o, i, l, a, s, c, u, d, p, h, f, m, g, y, E, b, C, N, T, S;
  a = n(0), s = n(18), y = n(1), i = n(7), E = (C = n(2)).func, b = C.oneOf, S = C.string, h = C.arrayOf, T = C.shape, f = n(19), d = n(20), p = n(6), m = (N = n(10)).controlNames, r = [(g = N.controlTypes).INLINE, g.BLOCK, g.LINK], c = {
    IN_BOLD: {
      label: "bold",
      style: "BOLD",
      type: g.INLINE,
      hasIcon: !0
    },
    IN_ITAL: {
      label: "italic",
      style: "ITALIC",
      type: g.INLINE,
      hasIcon: !0
    },
    IN_UNDER: {
      label: "underline",
      style: "UNDERLINE",
      type: g.INLINE,
      hasIcon: !0
    },
    IN_FSIZE: {
      label: "fsize",
      subControls: [m.FONT_SIZE_SMALL, m.FONT_SIZE_MODERATE, m.FONT_SIZE_NORMAL, m.FONT_SIZE_LARGE, m.FONT_SIZE_HUGE],
      type: g.INLINE,
      hasIcon: !0
    },
    IN_FSIZE_SMALL: {
      label: "small",
      style: "SMALL_FONT",
      type: g.INLINE
    },
    IN_FSIZE_MODERATE: {
      label: "moderate",
      style: "MODERATE_FONT",
      type: g.INLINE
    },
    IN_FSIZE_NORM: {
      label: "normal",
      style: "NORMAL_FONT",
      type: g.INLINE
    },
    IN_FSIZE_LRG: {
      label: "large",
      style: "LARGE_FONT",
      type: g.INLINE
    },
    IN_FSIZE_HUGE: {
      label: "huge",
      style: "HUGE_FONT",
      type: g.INLINE
    },
    IN_CLEARF: {
      label: "clearformat",
      style: "CLEAR_ALL",
      type: g.INLINE,
      hasIcon: !0
    },
    LINK: {
      label: "link",
      style: "LINK",
      type: g.LINK,
      hasIcon: !0
    },
    BL_UL: {
      label: "ul",
      style: "unordered-list-item",
      type: g.BLOCK
    },
    BL_ALIGN: {
      label: "align",
      type: g.BLOCK,
      subControls: [(_ref = {
        controlNames: m.ALIGNMENT_LEFT
      }, _defineProperty(_ref, "controlNames", m.ALIGNMENT_CENTER), _defineProperty(_ref, "controlNames", m.ALIGNMENT_RIGHT), _ref)],
      hasIcon: !0
    },
    BL_ALIGN_LT: {
      label: "left",
      style: "TEXT_ALIGN_LEFT",
      type: g.BLOCK,
      hasIcon: !0
    },
    BL_ALIGN_CNTR: {
      label: "center",
      style: "TEXT_ALIGN_CENTER",
      type: g.BLOCK,
      hasIcon: !0
    },
    BL_ALIGN_RT: {
      label: "right",
      style: "TEXT_ALIGN_RIGHT",
      type: g.BLOCK,
      hasIcon: !0
    }
  }, u = y({
    displayName: "StyleControl",
    propTypes: {
      onToggle: E.isRequired,
      type: b(r),
      label: S.isRequired,
      style: S
    },
    mixins: [p("editor")],
    handleMouseDown: function handleMouseDown(e) {
      var t, n, r;
      return e.preventDefault(), r = (t = this.props).type, n = t.style, this.props.onToggle({
        type: r,
        style: n
      });
    },
    render: function render() {
      var e, t, n, r, o;
      return t = (r = this.props).isActive, e = r.hasIcon, n = r.label, o = f("style-control", {
        icon: e,
        active: t
      }), a.createElement(d, null, a.createElement("div", {
        className: o,
        onMouseDown: this.handleMouseDown,
        title: this.i18n("tooltips." + n)
      }, a.createElement("span", {
        className: n
      }, e ? void 0 : this.i18n("labels." + n))));
    }
  }), l = y({
    displayName: "NestedStyleControl",
    propTypes: {
      label: S.isRequired,
      type: b(r),
      subControls: h(T({
        label: S.isRequired,
        style: S,
        type: b(r)
      })),
      onToggle: E.isRequired
    },
    mixins: [p("editor")],
    getInitialState: function getInitialState() {
      return {
        showNested: !1
      };
    },
    handleMouseDown: function handleMouseDown(e) {
      return e.preventDefault(), this.props.isExpanded ? this.props.collapseNestedControls() : this.props.expandNestedControls();
    },
    handleControlToggle: function handleControlToggle(e) {
      return this.props.onToggle(e);
    },
    _isSubControlActive: function _isSubControlActive(e) {
      return this.props.activeStyle.has(e.style);
    },
    renderNestedControls: function renderNestedControls() {
      return a.createElement("div", null, this.props.subControls.map((e = this, function (t, n) {
        return t.label, t.style, t.type, t.hasIcon, a.createElement(u, Object.assign({}, t, {
          key: n,
          onToggle: e.handleControlToggle,
          isActive: e._isSubControlActive(t)
        }));
      })));
      var e;
    },
    render: function render() {
      var e, t, n, r, o;
      return r = (o = this.props).label, t = o.hasIcon, n = o.isExpanded, e = f("style-control with-nested", {
        active: this.state.showControls
      }), a.createElement("div", {
        className: e,
        onMouseDown: this.handleMouseDown,
        style: {
          display: "inline-block"
        }
      }, a.createElement(d, null, a.createElement("span", {
        className: r,
        title: this.i18n("tooltips." + r)
      }, t ? void 0 : this.i18n("labels." + r))), n ? a.createElement("div", {
        className: "sub-controls"
      }, this.renderNestedControls()) : void 0);
    }
  }), o = y({
    displayName: "GdtEditorControls",
    propTypes: {
      stickTo: S,
      controlsOrder: h(S),
      customControls: h(T({
        label: S.isRequired,
        onToggle: E.isRequired
      }))
    },
    getInitialState: function getInitialState() {
      return {
        expandedNestedControls: null
      };
    },
    expandNestedControls: function expandNestedControls(e) {
      return t = this, function () {
        return t.setState({
          expandedNestedControls: e
        });
      };
      var t;
    },
    collapseNestedControls: function collapseNestedControls() {
      return this.setState({
        expandedNestedControls: null
      });
    },
    onToggle: function onToggle(e) {
      return this.setState({
        expandedNestedControls: null
      }), this.props.onToggle(e);
    },
    _onContainerScroll: function _onContainerScroll(e) {
      var t, n, r;
      return this, n = this.containerTop, r = this.initialTop, t = s.findDOMNode(this), r < n + this.container.scrollTop ? (t.style.position = "fixed", t.style.top = n + "px") : (t.style.position = "", t.style.top = "");
    },
    componentDidMount: function componentDidMount() {
      if (null != this.props.stickTo && (this.container = document.querySelector(this.props.stickTo)), this.container) return this.containerTop = this.container.getBoundingClientRect().top, this.initialTop = s.findDOMNode(this).getBoundingClientRect().top + this.container.scrollTop, this.container.addEventListener("scroll", this._onContainerScroll), this._onContainerScroll();
    },
    componentWillUnmount: function componentWillUnmount() {
      if (this.container) return this.container.removeEventListener("scroll", this._onContainerScroll), this.container = null, this.containerTop = null, this.initialTop = null;
    },
    renderBlockStyleControl: function renderBlockStyleControl(e, t) {
      var n, r, o, s, d, p, h, f, m, g;
      return d = e.label, h = e.style, f = e.subControls, g = e.type, s = e.hasIcon, r = "INLINE" === g ? null != (p = this.props.editorState) ? p.getCurrentInlineStyle() : void 0 : (o = this.props.editorState.getSelection(), n = this.props.editorState.getCurrentContent().getBlockForKey(o.getStartKey()).getType(), i.Set([n])), f ? (m = f.map(function (e) {
        return c[e];
      }), a.createElement(l, {
        key: t + "-in",
        label: d,
        hasIcon: s,
        subControls: m,
        onToggle: this.onToggle,
        expandNestedControls: this.expandNestedControls(d),
        collapseNestedControls: this.collapseNestedControls,
        isExpanded: this.state.expandedNestedControls === d,
        activeStyle: r
      })) : a.createElement(u, Object.assign({}, e, {
        key: t,
        onToggle: this.onToggle,
        isActive: r.has(h)
      }));
    },
    renderCustomControls: function renderCustomControls() {
      return !!this.props.customControls && this.props.customControls.map(function (e, t) {
        return a.createElement(u, Object.assign({}, e, {
          key: t
        }));
      });
    },
    render: function render() {
      return a.createElement("div", {
        className: "style-controls-container"
      }, this.props.controlsOrder.map((e = this, function (t, n) {
        var r;
        return "CUSTOM" === t ? e.renderCustomControls() : (r = c[t]) ? e.renderBlockStyleControl(r, n) : null;
      })));
      var e;
    }
  }), e.exports = o;
}, function (e, t, n) {
  var r, o, i, l, a, s;
  i = n(0), a = n(1), o = n(37), l = n(6), s = {
    modal: {
      content: {
        top: "40vh",
        bottom: "initial",
        width: "400px",
        backgroundColor: "#fff"
      }
    },
    button: {
      backgroundColor: "#009cca",
      color: "#fff",
      lineHeight: "30px",
      marginLeft: "10px",
      width: "100px"
    },
    input: {
      width: "220px",
      fontSize: "16px",
      lineHeight: "30px"
    }
  }, r = a({
    displayName: "LinkInputModal",
    mixins: [l("")],
    onSubmit: function onSubmit() {
      var e;
      return e = this.input.value, this.props.onSubmit(e);
    },
    render: function render() {
      var e, t, n, r;
      return n = s.modal, e = s.button, t = s.input, i.createElement(o, {
        style: n,
        contentLabel: "",
        onClose: this.props.onClose,
        isOpen: !0,
        closeButton: !0
      }, i.createElement("div", null, i.createElement("input", {
        ref: (r = this, function (e) {
          return r.input = e;
        }),
        style: t,
        placeholder: "Link...",
        autoFocus: !0
      }), i.createElement("button", {
        style: e,
        onClick: this.onSubmit
      }, this.i18n("actions.save"))));
    }
  }), e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u;
  o = n(0), a = n(1), l = (u = n(2)).bool, s = u.func, i = n(3), c = {
    content: {
      top: null,
      left: null,
      right: null,
      bottom: null,
      border: null,
      background: null,
      borderRadius: null,
      padding: null,
      position: null,
      overflow: null
    },
    overlay: {
      backgroundColor: "rgba(255, 255, 255, 0.85)"
    }
  }, r = a({
    displayName: "Modal",
    propTypes: {
      isOpen: l.isRequired,
      onClose: s,
      closeButton: l
    },
    render: function render() {
      var e;
      return ReactModal.setAppElement(document.body), o.createElement(ReactModal, Object.assign({}, this.props, {
        className: this.props.className,
        style: i.extend({}, c, this.props.style),
        contentLabel: null != (e = this.props.contentLabel) ? e : "",
        isOpen: this.props.isOpen
      }), this.props.title ? o.createElement("h2", null, this.props.title) : void 0, this.props.closeButton ? o.createElement("div", {
        className: "modal-close",
        onClick: this.props.onClose
      }) : void 0, this.props.children);
    }
  }), e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a;
  l = n(0), a = n(1), o = n(17), r = n(39), i = a({
    displayName: "EditorWithApply",
    mixins: [n(6)("")],
    getInitialState: function getInitialState() {
      return {
        showCancelApply: !1
      };
    },
    showCancelApply: function showCancelApply() {
      return this.setState({
        showCancelApply: !0
      });
    },
    hideCancelApply: function hideCancelApply() {
      return this.setState({
        showCancelApply: !1
      });
    },
    onFocus: function onFocus() {
      var e;
      return "function" == typeof (e = this.props).onFocus && e.onFocus(), this.showCancelApply();
    },
    onBlur: function onBlur(e) {
      var t;
      return "function" == typeof (t = this.props).onBlur && t.onBlur(e), this.hideCancelApply();
    },
    onCancel: function onCancel() {
      var e;
      return "function" == typeof (e = this.props).onCancel && e.onCancel(), this.hideCancelApply();
    },
    onApply: function onApply() {
      var e;
      return "function" == typeof (e = this.props).onApply && e.onApply(), this.hideCancelApply();
    },
    render: function render() {
      return l.createElement("div", null, l.createElement(o, Object.assign({}, this.props, {
        ref: (e = this, function (t) {
          return e.gdtEditor = t;
        }),
        onFocus: this.onFocus,
        onBlur: this.onBlur
      })), this.state.showCancelApply ? l.createElement(r, {
        onCancel: this.onCancel,
        onApply: this.onApply
      }) : void 0);
      var e;
    }
  }), e.exports = i;
}, function (e, t, n) {
  var r, o, i, l, a;
  i = n(0), l = n(1), a = n(2).func, o = n(40), r = l({
    displayName: "ApplyCancelButtons",
    propTypes: {
      onApply: a,
      onCancel: a
    },
    mixins: [n(6)("")],
    render: function render() {
      return i.createElement("div", {
        className: "row buttons-react"
      }, i.createElement("div", {
        className: "col-6"
      }, i.createElement(o, {
        className: "cancel btn btn-block",
        label: this.i18n("actions.cancel"),
        onMouseDown: this.props.onCancel
      })), i.createElement("div", {
        className: "col-6"
      }, i.createElement(o, {
        className: "apply btn btn-block btn-success",
        label: this.i18n("actions.apply"),
        onMouseDown: this.props.onApply
      })));
    }
  }), e.exports = r;
}, function (e, t, n) {
  var r, o, i, l;
  o = n(0), l = n(1), i = n(20), r = l({
    displayName: "Button",
    render: function render() {
      return o.createElement(i, null, o.createElement("button", Object.assign({}, this.props), this.props.label));
    }
  }), e.exports = r;
}, function (e, t, n) {
  var r, o, i, l, a, s, c, u, d, p, h, f, m, g, y;
  d = n(0), p = n(18), y = n(1), g = n(19), a = n(4).Entity, o = n(11), r = n(13), i = n(15), l = n(8), c = n(22), u = n(9), h = n(23), f = n(24), m = n(25), s = y({
    displayName: "InsertedGdtTable",
    mixins: [n(6)("")],
    getInitialState: function getInitialState() {
      return {
        expanded: !0
      };
    },
    _getEntityKey: function _getEntityKey() {
      return this.props.block.getEntityAt(0);
    },
    _getTableProps: function _getTableProps() {
      return a.get(this._getEntityKey()).getData();
    },
    renderTable: function renderTable() {
      var e, t, n, r;
      if (r = (n = this._getTableProps()).type, e = n.data, n.manualEdit) return t = "string" == typeof e ? e : e.html, d.createElement("div", {
        className: "embedded",
        dangerouslySetInnerHTML: {
          __html: t
        }
      });

      switch (r) {
        case "l1_sof":
        case "l2_sof":
          return d.createElement(c, {
            type: r,
            data: e,
            tableOnly: !0
          });

        case "evidence_short":
          return d.createElement(i, {
            data: e
          });

        case "relative_importance":
          return d.createElement(h, {
            data: e
          });

        case "sof_short":
          return d.createElement(f, {
            data: e
          });

        case "sof_v1":
        case "sof_v2":
        case "sof_v3":
          return d.createElement(m, {
            data: e
          });

        default:
          return !1;
      }
    },
    openTableInNewWindow: function openTableInNewWindow() {
      var e;
      return e = this._getTableProps().data, l.openTableInNewWindow(e.title, p.findDOMNode(this.tableContent).innerHTML);
    },
    toggleTable: function toggleTable(e) {
      return e.stopPropagation(), this.setState({
        expanded: !this.state.expanded
      });
    },
    collapsedTable: function collapsedTable() {
      var e, t, n, r, i, l;
      return e = this._getTableProps().data, l = this.i18n("editor.table") + ": <b>" + e.title + "</b>", n = 1 === t ? this.i18n("editor.outcome") : this.i18n("editor.outcomes"), t = null != (r = null != (i = e.outcomes) ? i.length : void 0) ? r : 0, d.createElement(o, {
        tableData: e,
        tableTitle: l,
        outcomesText: n + " " + t,
        onToggle: this.toggleTable,
        openInNewWindow: this.openTableInNewWindow,
        expandTitle: this.i18n("editor.expand_table"),
        openInNewWindowTitle: this.i18n("editor.open_table_in_new_window")
      });
    },
    render: function render() {
      return d.createElement("div", null, this.state.expanded && d.createElement("div", {
        className: "inserted-table_buttons-row"
      }, d.createElement(r, {
        label: this.i18n("editor.collapse_table"),
        onClick: this.toggleTable
      }), d.createElement(u, {
        label: this.i18n("editor.open_table_in_new_window"),
        onClick: this.openTableInNewWindow
      })), d.createElement("div", {
        ref: (e = this, function (t) {
          return e.tableContent = t;
        }),
        className: g({
          hidden: !this.state.expanded
        })
      }, this.renderTable()), !this.state.expanded && this.collapsedTable());
      var e;
    }
  }), e.exports = s;
}, function (e, t, n) {
  var r, o, i, l, a, s;
  i = n(0), s = n(1), o = n(7), r = n(4).Entity, a = n(3), l = s({
    displayName: "ReferenceCitation",
    _refToString: function _refToString(e) {
      var t, n, r, o;
      return t = e.get("authors"), o = null != (n = e.get("year").match(/\d{4}/)) ? n[0] : void 0, r = t.first().get("lastName"), t.size > 1 && (r += " et al."), r + ", " + o;
    },
    getDeduplicatedReferences: function getDeduplicatedReferences() {
      return this.props.references ? this.props.references.filterNot(function (e) {
        return "merged" === e.get("deduplicationStatus");
      }) : new o.List();
    },
    getReferenceByIds: function getReferenceByIds(e) {
      var t;
      return e = [].concat(e), t = this.getDeduplicatedReferences(), o.List(e).map(function (e) {
        return t.find(function (t) {
          return t.get("_id") === e;
        });
      });
    },
    getReferences: function getReferences() {
      var e;
      return e = r.get(this.props.entityKey).getData().refIds, this.getReferenceByIds(e).filter(function (e) {
        return void 0 !== e;
      }).interpose(", ");
    },
    render: function render() {
      var e, t;
      return !(e = this.getReferences()).isEmpty() && i.createElement("span", {
        style: {
          backgroundColor: "#ebebeb"
        }
      }, i.createElement("span", null, "("), e.map((t = this, function (e, n) {
        return e ? a.isString(e) ? i.createElement("span", {
          key: n
        }, e) : i.createElement("span", {
          key: n,
          "data-refid": e.get("_id")
        }, t._refToString(e)) : "";
      })), this.props.children);
    }
  }), e.exports = l;
}, function (e, t, n) {}]);